<script lang="ts" setup>
withDefaults(
  defineProps<{
    isLg?: boolean
    isDense?: boolean
    isTransparent?: boolean
    isNoMobilePadding?: boolean
  }>(),
  {}
)
</script>

<template>
  <div
    class="rounded-lg"
    :class="{
      'p-6': isLg,
      'p-2': isDense,
      'p-4': !isLg && !isDense,
      'max-sm:px-0': isNoMobilePadding,
      'bg-midnight-700 border border-midnight-600': !isTransparent
    }"
  >
    <slot />
  </div>
</template>
